import React from 'react';
import { Button, Size, Theme } from '../../../Button';
import Grid from '../../../Grid';
import styles from './action-button.module.scss';
const SearchActionButton = ({ label, onSubmit, errors, md, lg, theme }) => (<Grid.Col xs={12} md={md || 4} lg={lg || 12} gutter={0} className={styles.submitContainer}>
    <Button block scale={Size.LARGE_SIZE} theme={theme || Theme.PRIMARY_THEME} onClick={onSubmit} disabled={errors}>
      {label}
    </Button>
  </Grid.Col>);
export default SearchActionButton;
